import React from 'react';
import { FormattedDate } from 'react-intl';

import { Text } from '@atlaskit/primitives/compiled/text';

import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import type { ChangeHistoryVersion } from '../changeHistoryMacroTypes.ts';

export type VersionDateProps = {
	version: ChangeHistoryVersion;
	isCurrent: boolean;
};

export const VersionDate = ({ version, isCurrent }: VersionDateProps): React.JSX.Element => {
	const sessionData = useSessionData();

	// Session data is shared by SSR and hydration; runtime timezones can differ.
	const content = version.when ? (
		<FormattedDate
			value={new Date(version.when)}
			{
				// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
				...(fg('cc-dlp-fix-change-history-macro-ssr-date-bug')
					? { timeZone: sessionData.timeZone || sessionData.tenantTimeZone || undefined }
					: {})
			}
			year="numeric"
			month="short"
			day="numeric"
			hour="numeric"
			minute="numeric"
		/>
	) : (
		version.friendlyWhen
	);

	return isCurrent ? <Text as="strong">{content}</Text> : <Text>{content}</Text>;
};
